const getters = {
    token: state => state.user.token,
    urid: state => state.user.userid,
}
export default getters
